import axios from 'axios';

import env from '../env';

const client = axios.create({
  baseURL: env.AUTHENTICATE_API,
});

export default client;
